import ZenPilatesRegisterView from "views/ZenPilatesRegisterView/ZenPilatesRegisterView";

export default function RegisterPage() {
    return (
        <ZenPilatesRegisterView />
    );
}
